import httpService from '@Utils/httpService';

/**
 * Save global offset and unit scale for a model
 * @param {string} assetId - The facility/asset ID
 * @param {Object} globalOffset - Object with x, y, z properties
 * @param {number} unitScale - The unit scale value
 * @returns {Promise} Response with modelName, unitScale, globalOffset, hasData
 */
export function saveModelOffsets(assetId, globalOffset, unitScale) {
    return httpService.post({
        url: 'api/forge/models/saveOffsets',
        data: {
            assetId: assetId,
            globalOffset: {
                x: globalOffset.x,
                y: globalOffset.y,
                z: globalOffset.z
            },
            unitScale: unitScale
        }
    });
}

/**
 * Get saved global offset and unit scale for a model
 * @param {string} assetId - The facility/asset ID
 * @returns {Promise} Response with modelName, unitScale, globalOffset, hasData
 */
export function getModelOffsets(assetId, config = {}) {
    return httpService.get({
        url: 'api/forge/models/getOffsets',
        params: { assetId },
        ...config,
    });
}
